/* HMX V53 — keep cart benefit messaging accurate and quantity controls visible after Shopify redraws. */
(() => {
  'use strict';
  if (window.__HMX_V53_CART_CHECKOUT_POLISH__) return;
  window.__HMX_V53_CART_CHECKOUT_POLISH__ = true;

  const compact = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const formatCompactMoney = (value) => compact(value).replace(/([.,])00(?=\D*$)/, '');

  const buttonIntentText = (button) => [
    button.getAttribute('name'),
    button.getAttribute('aria-label'),
    button.getAttribute('title'),
    button.dataset.action,
    button.dataset.hmxQuantityIntent,
    button.className,
    button.textContent
  ].filter(Boolean).join(' ').toLowerCase();

  const repairQuantityControls = (drawer) => {
    drawer.querySelectorAll('#CartDrawer quantity-input').forEach((quantity) => {
      const buttons = Array.from(quantity.querySelectorAll(':scope > button'));
      if (buttons.length < 2) return;

      const minus = buttons.find((button) => /minus|decrease|decrement|subtract/.test(buttonIntentText(button))) || buttons[0];
      const plus = buttons.find((button) => /plus|increase|increment|add/.test(buttonIntentText(button))) || buttons[buttons.length - 1];
      if (!minus || !plus || minus === plus) return;

      minus.setAttribute('name', 'minus');
      minus.dataset.hmxV53QuantityIntent = 'minus';
      if (!minus.getAttribute('aria-label')) minus.setAttribute('aria-label', 'Decrease quantity');

      plus.setAttribute('name', 'plus');
      plus.dataset.hmxV53QuantityIntent = 'plus';
      plus.setAttribute('aria-label', 'Increase quantity');

      const glyphs = Array.from(plus.querySelectorAll(':scope > .hmx-quantity-plus-glyph'));
      let glyph = glyphs.shift();
      glyphs.forEach((duplicate) => duplicate.remove());
      if (!glyph) {
        glyph = document.createElement('span');
        glyph.className = 'hmx-quantity-plus-glyph';
        glyph.setAttribute('aria-hidden', 'true');
        plus.appendChild(glyph);
      }
      if (glyph.textContent !== '+') glyph.textContent = '+';
    });
  };

  const apply = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    repairQuantityControls(drawer);

    const firstBenefit = drawer.querySelector('.hmx-cart-v4__benefit-bar .hmx-cart-v4__benefit:first-child span');
    if (!firstBenefit) return;

    const savings = drawer.querySelector('.hmx-cart-v7__savings strong');
    const amount = formatCompactMoney(savings?.textContent || '');
    const next = amount ? `SAVE ${amount}` : 'SECURE CHECKOUT';

    if (compact(firstBenefit.textContent) !== next) firstBenefit.textContent = next;
    firstBenefit.closest('.hmx-cart-v4__benefit')?.setAttribute('aria-label', next);
  };

  const run = () => [0, 80, 220, 500].forEach((delay) => window.setTimeout(apply, delay));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('cart:updated', run);
  document.addEventListener('cart-drawer:open', run);
  document.addEventListener('shopify:section:load', run);

  const observer = new MutationObserver(() => window.setTimeout(apply, 30));
  const startObserver = () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) observer.observe(drawer, { childList: true, subtree: true, characterData: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }
})();
